import React from 'react'
import '../Navbar/Navbar.css'
import { Link } from 'react-router-dom'

function Navbar() {
  return (
<div>
 <div className='new4_bg'>
<section
  className="elementor-section elementor-inner-section elementor-element elementor-element-ad05ee8 elementor-section-full_width elementor-section-content-middle elementor-section-height-default elementor-section-height-default"
  data-id="ad05ee8"
  data-element_type="section"
  data-settings='{"wdt_bg_image":{"url":"","id":"","size":""},"wdt_bg_image_laptop":{"url":"","id":"","size":""},"wdt_bg_image_tablet_extra":{"url":"","id":"","size":""},"wdt_bg_image_tablet":{"url":"","id":"","size":""},"wdt_bg_image_mobile_extra":{"url":"","id":"","size":""},"wdt_bg_image_mobile":{"url":"","id":"","size":""},"wdt_bg_position":"center center","wdt_animation_effect":"none"}'
>
  <div className="elementor-container elementor-column-gap-no">
    <div
      className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-ea51e31"
      data-id="ea51e31"
      data-element_type="column"
    >
      <div className="elementor-widget-wrap elementor-element-populated">
        <div
          className="elementor-element elementor-element-473b355 elementor-widget elementor-widget-wdt-logo"
          data-id="473b355"
          data-element_type="widget"
          data-settings='{"wdt_animation_effect":"none"}'
          data-widget_type="wdt-logo.default"
        >
          <div className="elementor-widget-container">
            <div id="a-for-apple-473b355" className="wdt-logo-container">
              {" "}
              <a href="./a-for-apple/" rel="home">
                <img
                  loading="lazy"
                  src="./SSVNLOGOO.png"
                  alt="AforApple WP Theme"
                  width={214}
                  height={61}
                />
              </a>
            </div>{" "}
          </div>
        </div>
      </div>
    </div>
    <div
      className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-8c66bed elementor-hidden-tablet_extra elementor-hidden-tablet elementor-hidden-mobile_extra elementor-hidden-mobile"
      data-id="8c66bed"
      data-element_type="column"
    >
      <div className="elementor-widget-wrap elementor-element-populated">
        <div
          className="elementor-element elementor-element-6b4df91 elementor-align-center elementor-widget-tablet_extra__width-auto elementor-hidden-tablet_extra elementor-hidden-tablet elementor-hidden-mobile_extra elementor-hidden-mobile elementor-widget elementor-widget-wdt-header-menu"
          data-id="6b4df91"
          data-element_type="widget"
          data-settings='{"wdt_animation_effect":"none"}'
          data-widget_type="wdt-header-menu.default"
        >
          <div className="elementor-widget-container">
            <div className="wdt-header-menu" data-menu={16}>
              <div className="menu-container" >
                <ul
                  id="menu-main-menu-2"
                  className="wdt-primary-nav "
                  data-menu={16}
                >
                  {" "}
                  <li className="close-nav">
                    <a href="javascript:void(0);" />
                  </li>{" "}
                  <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-28768 menu-item-depth-0">
                    <Link to="/">
                      <span data-text="About Us">Home</span>
                    </Link>
                  </li>
                 
                  <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-28768 menu-item-depth-0">
                    <Link to="/myabout">
                      <span data-text="About Us">About Us</span>
                    </Link>
                  </li>
                 

                  <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-28768 menu-item-depth-0">
                    <Link to="/Ourprograms">
                      <span data-text="About Us">OurPrograms</span>
                    </Link>
                  </li>


                    <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-28768 menu-item-depth-0">
                    <Link to="/Gallery">
                      <span data-text="About Us">Gallery</span>
                    </Link>
                  </li>

                  
                  <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-28768 menu-item-depth-0">
                    <Link to="/Contact">
                      <span data-text="ContactUs">Contact</span>
                    </Link>
                  </li>
                

                 

                </ul>{" "}
                <div className="sub-menu-overlay" />
              </div>
              <div
                className="mobile-nav-container mobile-nav-offcanvas-right"
                data-menu={16}
              >
                <a
                  href="#"
                  className="menu-trigger menu-trigger-icon"
                  data-menu={16}
                >
                  <i />
                  <span>Menu</span>
                </a>
                <div className="mobile-menu" data-menu={16} />
                <div className="overlay" />
              </div>
            </div>{" "}
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

    </div>
    </div>

  )
}

export default Navbar

